/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

export default addMapEntry;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_addMapEntry.js
// module id = 338
// module chunks = 0